import loggedUserRedirect from '~~/modules/auth/composables/useAuthRedirect'
import fetchUserIsLogged from '~~/modules/api/rurality/v3/user/is-logged'

export default defineNuxtRouteMiddleware(async to => {
  // skip middleware on client side entirely
  if (import.meta.client) return

  const reqHeaders = useRequestHeaders(['referer'])

  let previousUrl: false | string = false

  // the referrer comes when there has been a normal navigation, for example clicking an <a> link in a page. It comes from the http headers
  if (reqHeaders.referer !== undefined) {
    const url = new URL(reqHeaders.referer)
    previousUrl = url.pathname + url.search
  }
  // the redirectedFrom comes when there has been a server side redirection with navigateTo a external: false. It comes from the vue-router
  else if (to.redirectedFrom?.fullPath) {
    previousUrl = to.redirectedFrom.fullPath
  }

  const returnUrl = useCookie('returnUrl', { maxAge: 900 })

  const {
    isAuthRoute,
    isPrivateRoute,
    isOwnerRegisterRoute,
    isNewOwnerLandingUrl,
  } = routesValidation()

  if (isAuthRoute(to.path) || isPrivateRoute(to.path)) {
    const authUserIsLogged = await fetchUserIsLogged()
    if (
      previousUrl &&
      isNewOwnerLandingUrl(previousUrl) &&
      isOwnerRegisterRoute(to.path) &&
      authUserIsLogged.logged === true &&
      authUserIsLogged.type.toLowerCase() === 'traveler'
    ) {
      return navigateTo(routes().ownerRegistrationAsTraveler())
    } else if (
      isAuthRoute(to.path) &&
      authUserIsLogged.type &&
      authUserIsLogged.id
    ) {
      return navigateTo(
        loggedUserRedirect({
          userType: authUserIsLogged.type,
          userId: authUserIsLogged.id,
          isOwnerRegister: isOwnerRegisterRoute(to.path),
        }),
        {
          external: true,
        },
      )
    } else if (authUserIsLogged.logged === false) {
      if (isPrivateRoute(to.path)) {
        returnUrl.value = to.fullPath
        return navigateTo(routes().login())
      } else if (isAuthRoute(to.path) && previousUrl) {
        if (!isAuthRoute(previousUrl) && !returnUrl.value) {
          returnUrl.value = previousUrl
        }
      }
    }
  }

  return
})
